const primaryServices = [
  {
    icon: 'ri-home-2-line',
    title: 'Roof Replacement',
    description: 'Complete roof system replacements engineered for South Bay weather — from material selection to final inspection. Built for durability and long-term value.',
    image: 'https://lirp.cdn-website.com/785a78af/dms3rep/multi/opt/pexels-photo-33404981-1920w.jpeg',
    alt: 'Professional roof replacement on a residential home in Campbell, CA',
    tag: 'Most Popular',
  },
  {
    icon: 'ri-tools-line',
    title: 'Roof Repair',
    description: 'Targeted repairs that resolve leaks, damaged shingles, and structural issues — without unnecessary full replacement. Fast diagnosis, lasting results.',
    image: 'https://public.readdy.ai/ai/img_res/356eef53df88a1f59d6b2ec878a66e39.jpg',
    alt: 'Expert roof repair service for South Bay homeowners',
    tag: null,
  },
  {
    icon: 'ri-sun-line',
    title: 'Solar Installation',
    description: 'Residential solar systems designed to maximize energy generation for Campbell\'s strong sun exposure. Paired with battery storage for full energy independence.',
    image: 'https://lirp.cdn-website.com/785a78af/dms3rep/multi/opt/Shadow-roofing-and-solar-12-1920w.webp',
    alt: 'Solar panel installation on residential roof in the South Bay, California',
    tag: null,
  },
  {
    icon: 'ri-drop-line',
    title: 'Gutter Systems',
    description: 'Precision gutter installation and gutter screen systems that manage seasonal Bay Area rain and protect your home from water damage and erosion.',
    image: 'https://lirp.cdn-website.com/785a78af/dms3rep/multi/opt/shutterstock_2494327827-1920w.jpg',
    alt: 'Gutter replacement and installation service in Campbell and South Bay',
    tag: null,
  },
  {
    icon: 'ri-battery-2-charge-line',
    title: 'Battery Systems',
    description: 'Energy storage solutions that pair with solar to keep your home powered day and night — reducing grid dependence and maximizing your solar investment.',
    image: 'https://lirp.cdn-website.com/785a78af/dms3rep/multi/opt/Shadow-roofing-and-solar-7-1920w.webp',
    alt: 'Home battery storage system installation in Campbell, CA',
    tag: null,
  },
  {
    icon: 'ri-building-2-line',
    title: 'Flat & Metal Roofing',
    description: 'TPO, PVC flat roofing and metal roofing systems for residential and commercial properties. Durable, low-maintenance solutions built for longevity.',
    image: 'https://readdy.ai/api/search-image?query=modern%20flat%20TPO%20commercial%20roofing%20installation%20California%20professional%20crew%20working%20on%20clean%20flat%20roof%20surface%20aerial%20perspective%20minimal%20background%20bright%20daylight&width=600&height=400&seq=svc-flat-03&orientation=landscape',
    alt: 'Flat roofing and metal roofing installation in the South Bay',
    tag: null,
  },
];

const additionalServices = [
  'Gutter Screens',
  'Skylight Replacement',
  'Commercial Solar',
  'Solar & Electrical Evaluations',
];

export default function Services() {
  const handleNav = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="services" className="bg-white py-28">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">

        {/* Section Header */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-16">
          <div>
            <span
              className="text-[#d4af37] text-[10px] uppercase tracking-[4px] font-bold block mb-4"
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              What We Do
            </span>
            <h2
              className="font-black text-[#0d1a27] leading-[1.0]"
              style={{ fontFamily: "'Montserrat', sans-serif", fontSize: 'clamp(2.2rem, 4vw, 3.5rem)', letterSpacing: '-0.02em' }}
            >
              Roofing &amp; Solar Services
              <br />
              <span className="text-[#d4af37]">Built for the South Bay</span>
            </h2>
          </div>
          <p
            className="text-[#777] text-sm leading-[1.8] max-w-xs"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            From roof replacement to solar installation, every project is handled with precision, transparency, and a commitment to long-term performance.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-8">
          {primaryServices.map((service, idx) => (
            <article
              key={idx}
              className="group relative bg-white rounded-lg overflow-hidden border border-[#eeede8] hover:border-[#d4af37]/40 transition-all duration-400 hover:-translate-y-1.5"
              style={{ boxShadow: '0 1px 3px rgba(0,0,0,0.04)' }}
            >
              {service.tag && (
                <div className="absolute top-4 right-4 z-10 bg-[#d4af37] text-[#1a1a1a] text-[9px] font-black uppercase tracking-[1.5px] px-3 py-1.5 rounded-full">
                  {service.tag}
                </div>
              )}

              {/* Image */}
              <div className="w-full overflow-hidden relative" style={{ height: '210px' }}>
                <img
                  src={service.image}
                  alt={service.alt}
                  className="w-full h-full object-cover object-top group-hover:scale-[1.04] transition-transform duration-600"
                />
                {/* Subtle gradient on image bottom */}
                <div className="absolute bottom-0 left-0 right-0 h-12 bg-gradient-to-t from-white/20 to-transparent"></div>
              </div>

              {/* Content */}
              <div className="p-7">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full flex-shrink-0" style={{ background: 'rgba(13,26,39,0.06)' }}>
                    <i className={`${service.icon} text-[#0d1a27] text-base`}></i>
                  </div>
                  <h3
                    className="text-[#0d1a27] font-bold text-[15px] leading-snug"
                    style={{ fontFamily: "'Montserrat', sans-serif" }}
                  >
                    {service.title}
                  </h3>
                </div>
                <p
                  className="text-[#777] text-sm leading-[1.75]"
                  style={{ fontFamily: "'Inter', sans-serif" }}
                >
                  {service.description}
                </p>
              </div>

              {/* Bottom gold accent on hover */}
              <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-[#d4af37] scale-x-0 group-hover:scale-x-100 transition-transform duration-400 origin-left"></div>
            </article>
          ))}
        </div>

        {/* Additional Services Pills */}
        <div className="flex flex-wrap items-center gap-3 mb-14 pb-14 border-b border-[#f0f0ec]">
          <span
            className="text-[#bbb] text-[10px] uppercase tracking-[2px] font-semibold"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            Also:
          </span>
          {additionalServices.map((s, i) => (
            <span
              key={i}
              className="border border-[#e8e8e4] text-[#666] text-xs px-4 py-2 rounded-full bg-[#fafaf8] hover:border-[#d4af37]/40 transition-colors duration-200"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              {s}
            </span>
          ))}
        </div>

        {/* CTA after services */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-5">
          <button
            onClick={() => handleNav('#contact')}
            className="group inline-flex items-center gap-3 bg-[#0d1a27] hover:bg-[#162d47] text-white font-bold text-xs px-10 py-4 rounded transition-all duration-300 cursor-pointer whitespace-nowrap uppercase tracking-[2px]"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            Request a Free Assessment
            <div className="w-5 h-5 flex items-center justify-center group-hover:translate-x-1 transition-transform duration-300">
              <i className="ri-arrow-right-line"></i>
            </div>
          </button>
          <a
            href="tel:4086280065"
            className="inline-flex items-center gap-2 text-[#555] hover:text-[#d4af37] font-semibold text-sm transition-colors duration-300 whitespace-nowrap"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-phone-fill text-[#d4af37]"></i>
            </div>
            Or call (408) 628-0065
          </a>
        </div>
      </div>
    </section>
  );
}
